import styled from 'styled-components'

import { color, radius, spacing } from '../../themes'

export const ScrollContainer = styled.div`
  display: flex;
  overflow-x: auto;
  padding-bottom: ${spacing(2)};
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */

  &::-webkit-scrollbar {
    height: 4px;
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: ${color('gray.05')};
  }

  &::-webkit-scrollbar-thumb {
    border-radius: ${radius('full')};
    background-color: ${color('gray.04')};
  }
`

export const Container = styled.ol`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  /* flex-wrap: wrap; */
`
